/**
 * @module learning content ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { uiActions } from '~/behaviors/actions/ui.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { learningContentActions } from '~/behaviors/actions/learning_content.actions';
import { convert } from '~/tools/convert';

const defaultState = {
  filterBy: {
    contentType: null,
    tagIds: [],
    categoryIds: [],
  },
  orderBy: 'name',
  order: 'asc',
  search: '',
  isLoadingContents: false,
  isLoadingTags: false,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const changeUI = (state, action) => {
  const { filterBy, ...remainingUpdates } = action?.payload || {};
  // @ts-expect-error TS(2345): Argument of type 'string[]' is not assignable to p... Remove this comment to see the full error message
  const sanitizedFilters = convert.pick(filterBy, Object.keys(defaultState.filterBy));
  // @ts-expect-error TS(2345): Argument of type 'string[]' is not assignable to p... Remove this comment to see the full error message
  const sanitizedAttrs = convert.pick(remainingUpdates, Object.keys(defaultState));

  return {
    ...state,
    ...sanitizedAttrs,
    filterBy: {
      ...state.filterBy,
      ...sanitizedFilters,
    },
  };
};

const learningContentUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(uiActions.changeLearningContentUI, changeUI);

  builder.addCase(learningContentActions.fetchLearningContents.pending, merge({ isLoadingContents: true }));
  builder.addCase(learningContentActions.fetchLearningContents.fulfilled, merge({ isLoadingContents: false }));
  builder.addCase(learningContentActions.fetchLearningContents.rejected, merge({ isLoadingContents: false }));

  builder.addCase(learningContentActions.fetchLearningTags.pending, merge({ isLoadingTags: true }));
  builder.addCase(learningContentActions.fetchLearningTags.fulfilled, merge({ isLoadingTags: false }));
  builder.addCase(learningContentActions.fetchLearningTags.rejected, merge({ isLoadingTags: false }));
});

export default learningContentUI;
